<template>
  <div :class="$vuetify.breakpoint.mobile?'px-0':'pr-4'">
    <v-app-bar-nav-icon @click="toggleNotificationDrawer">
      <v-badge style="padding:2px"
        color="#ff4927"
        :content="unreadNotificationCounter"
        :value="unreadNotificationCounter"
        overlap
      >
        <div>
          <div class="notification-bell">
            <span class="bell-top"></span>
            <span class="bell-middle"></span>
            <span class="bell-bottom"></span>
            <span class="bell-rad"></span>
          </div>
        </div>
      </v-badge>
    </v-app-bar-nav-icon>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  name: 'NotificationHeaderButton',
  data: function () {
    return { }
  },
  computed: {
    ...mapState(['unreadNotificationCounter', 'processingNotificationQueue'])
  },
  methods: {
    ...mapMutations(['toggleNotificationDrawer']),
    ...mapActions(['getPendingNotificationNumber'])
  },
  created () {
    this.getPendingNotificationNumber()
  },
  watch: {
    processingNotificationQueue () {
      this.getPendingNotificationNumber()
    }
  }
}
</script>

<style scoped>
.v-menu__content {
  border-radius: 0.25rem;
  margin-top: 16px;
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  box-shadow: none;
  box-shadow: 0 5px 12px rgb(0 0 0 / 10%);
}

.text-muted {
  color: #74788d !important;
  font-size: 14px !important;
}
@keyframes bellx {
  0% {
    transform: rotate(0deg) !important;
  }
  7.5% {
    transform: rotate(25deg)!important;
  }
  30% {
    transform: rotate(-25deg)!important;
  }
  45% {
    transform: rotate(15deg)!important;
  }
  58% {
    transform: rotate(-10deg)!important;
  }
  70% {
    transform: rotate(5deg)!important;
  }
  87.5% {
    transform: rotate(-2deg)!important;
  }
  100% {
    transform: rotate(0deg)!important;
  }
}

@keyframes rad {
  0% {
  }
  15% {
    transform: translateX(-5px) rotate(7deg);
  }
  32.5% {
    transform: translateX(5px) rotate(-7deg);
  }
  50% {
    transform: translateX(-5px) rotate(7deg);
  }
  65% {
    transform: translateX(5px) rotate(-7deg);
  }
  80% {
    transform: translateX(-5px) rotate(7deg);
  }
  90% {
    transform: translateX(0px) rotate(-7deg);
  }
  100% {
  }
}

@keyframes zoom {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  10% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 1;
  }
  51% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
.notification-bell {
  animation: bell 2s 1s both 2!important;
}

.notification-bell * {
  display: block!important;
  margin: 0 auto;
  background-color: transparent;
}

.bell-top {
  width: 6px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: #505d69;
}

.bell-middle {
  width: 15px!important;
  height: 15px!important;
  margin-top: -1px!important;
  border-radius: 12.5px 12.5px 0 0!important;
  border:1px solid #505d69!important;
}

.bell-bottom {
  position: relative;
  z-index: 0;
  width: 20px;
  height: 2px;
  background-color: #505d69;
  margin-top: -2px;
  border-radius: 5px;
}

.bell-bottom::before,
.bell-bottom::after {
  content: '';
  position: absolute;
  top: -4px;
}

.bell-bottom::before {
  left: 1px;
  border-bottom: 0px solid transparent;
  border-right: 0 solid transparent;
  border-left: 0px solid transparent;
}

.bell-bottom::after {
  right: 1px;
  border-bottom: 0px solid transparent;
  border-right: 0px solid transparent;
  border-left: 0 solid transparent;
}

.bell-rad {
  width: 8px;
  height: 2px;
  margin-top: 3px;
  border-radius: 5px;
  animation: rad 2s 1s both 2;
  background: #505d69;
}

.notification-count {
  z-index: 10 !important;
  position: absolute!important;
  top: 15px;
  right: 86px;
  width: 16px !important;
  height: 16px !important;
  line-height: 16px;
  font-size: 11px;
  border-radius: 50%;
  background-color: #ff4927;
  color: #fff;
  animation: zoom 8s 3s both 1;
}

.notification-box {
  position: inherit;
  z-index: 99;
  top: 30px !important;
  right: 3px;
  width: 50px;
  height: 50px;
  text-align: center;
  padding-top: 12px;
}
</style>
